module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjQ0IiB2aWV3Qm94PSItMTEgLTExIDQ0IDQ0IiB3aWR0aD0iNDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNLTExIC0xMWg0NHY0NEgtMTF6IiBmaWxsPSJub25lIi8+CiAgICA8Y2lyY2xlIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMnB4IiBmaWxsPSIjMUU4OEU1IiBjeD0iMTEiIGN5PSIxMSIgcj0iNyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/AddressMarkers/agency.svg
// module id = 1225
// module chunks = 0 2